import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getAuthorizationStep = createSelector(membersState, (members) => members.authorizationStep);
